// test1108
(1108 && 0);
